let socket = null;
let lockReconnect = false; // 重连锁
let timeout = null; // 重连定时器
let heartTimer = null; // 心跳定时器
let currentUserId = localStorage.getItem('userId');
// const SOCKET_URL = 'ws://106.15.73.171:6320/'; //本地
const SOCKET_URL = 'wss://xwd.juneng.yun/'; //线上
// 心跳配置（必须加，否则后端会断开）
const HEART_BEAT_INTERVAL = 25000; // 25秒发一次心跳（与注释一致，避免 1s 频繁唤醒主线程）
const HEART_BEAT_MSG = 'yes';

// 创建连接
export function createWebSocket(userId) {
  // 清理旧连接
  if (socket) {
    socket.close();
    socket = null;
  }

  // 优先使用传入的userId
  currentUserId = userId || currentUserId || localStorage.getItem('userId');
  
  if (!currentUserId) {
    console.log('WebSocket 无法连接：userId 为空');
    return;
  }

  const wsUrl = SOCKET_URL + `admin-api/ws/${currentUserId}`;

  try {
    socket = new WebSocket(wsUrl);
    initEvent();
  } catch (e) {
    console.log('连接异常', e);
    reconnect();
  }
}

// 初始化事件
function initEvent() {
  // 连接成功
  socket.onopen = () => {
    console.log('✅ WebSocket 连接成功');
    lockReconnect = false;
    startHeartBeat(); // 连接成功 → 启动心跳
  };

  // 收到消息
  socket.onmessage = (msg) => {
    // 后端心跳：isOnline → 必须回复 yes
    if (msg.data === 'isOnline') {
      sendMessage(HEART_BEAT_MSG);
      return;
    }

    // 业务消息
    try {
      const data = msg.data;
      window.dispatchEvent(new CustomEvent('wsMessage', { detail: data }));
    } catch (e) {}
  };

  // 关闭
  socket.onclose = (e) => {
    console.log('❌ WebSocket 断开', e, e.reason);
    stopHeartBeat();
    reconnect();
  };

  // 错误
  socket.onerror = (err) => {
    console.log('⚠️ WebSocket 出错', err);
    stopHeartBeat();
    reconnect();
  };
}

// 启动心跳（关键！防止后端断开）
function startHeartBeat() {
  heartTimer = setInterval(() => {
    if (socket && socket.readyState === 1) {
      socket.send(HEART_BEAT_MSG);
    }
  }, HEART_BEAT_INTERVAL);
}

// 停止心跳
function stopHeartBeat() {
  clearInterval(heartTimer);
}

// 重连
function reconnect() {
  if (lockReconnect) return;
  if (!currentUserId) return;

  lockReconnect = true;
  clearTimeout(timeout);

  // 3秒重连一次
  timeout = setTimeout(() => {
    createWebSocket();
    lockReconnect = false;
  }, 3000);
}

// 发送消息
export function sendMessage(data) {
  if (!socket || socket.readyState !== 1) return;

  if (typeof data === 'string') {
    socket.send(data);
  } else {
    socket.send(JSON.stringify(data));
  }
}

// 关闭连接（用户退出时调用）
export function closeWebSocket() {
  if (socket) {
    socket.close();
  }
  socket = null;
  lockReconnect = true; // 禁止重连
  currentUserId = null;
  clearTimeout(timeout);
  stopHeartBeat();
}

export default {
  createWebSocket,
  sendMessage,
  closeWebSocket,
};